/**
 * Reine Helfer + Query-Keys für die Bulk-Channel-Texte Review-Queue.
 *
 * Terminal-Stop-Muster für Polling: `isRunActive` entscheidet, ob ein Run noch
 * pollt (pending|running) oder final ist. Query-Keys folgen dem Muster aus
 * `hooks/useListingBuilder.ts` (Array-Präfix `['textRuns', ...]`, Filter-Objekt
 * als letztes Segment für Cache-Trennung je Filterkombination).
 */

import type {
  RunStatus,
  SuggestionRoute,
  SuggestionStatus,
} from '@/lib/api/channel-content-bulk'

const ACTIVE_RUN_STATUSES = new Set<RunStatus>(['pending', 'running'])

/** true solange der Run noch läuft (pending|running) — steuert das Polling. */
export function isRunActive(status: RunStatus): boolean {
  return ACTIVE_RUN_STATUSES.has(status)
}

/** true sobald der Run einen Endzustand erreicht hat (Kehrwert von isRunActive). */
export function isRunFinal(status: RunStatus): boolean {
  return !isRunActive(status)
}

/** Filter der Review-Queue (Muster `listSuggestions`-Payload aus dem API-Client). */
export interface SuggestionFilters {
  run_id?: string
  route?: SuggestionRoute
  status?: SuggestionStatus
  channel_id?: string
  page?: number
}

export const textRunKeys = {
  all: ['textRuns'] as const,
  runs: (page: number) => [...textRunKeys.all, 'runs', page] as const,
  run: (id: string) => [...textRunKeys.all, 'run', id] as const,
  suggestions: (filters: SuggestionFilters) =>
    [...textRunKeys.all, 'suggestions', filters] as const,
}
